"use strict";

var _envConstants = require("../env-constants");
// const { ENV } = require('../env-constants');

var config = {
  routePrefix: '',
  apiUrl: _envConstants.ENV.API_URL
};
var logo = {
  tyw: {
    href: '/',
    icon: {
      name: 'tyw-mini-logo',
      dark: 'black',
      light: 'white'
    }
  },
  tsw: {
    href: '/',
    icon: {
      name: 'tsw-logo',
      dark: '--color-primary',
      light: 'white'
    }
  },
  ynf: {
    href: 'https://www.yachtsandfriends.com',
    icon: {
      name: 'ynf-logo-fill',
      dark: '--color-secondary',
      light: 'white'
    }
  },
  qd: {
    href: '/',
    icon: {
      name: 'qd-logo',
      dark: '--color-secondary',
      light: 'white'
    }
  }
};
var bookingLink = {
  tyw: {
    link: '/browse',
    text: 'Book now'
  },
  tsw: {
    link: '/book',
    text: 'Book now'
  },
  ynf: {
    link: 'https://www.theyachtweek.com/browse/yachtsandfriends',
    text: 'Book now'
  },
  qd: {
    link: '/apply',
    text: 'Apply'
  }
};
var navbar = {
  tyw: {
    links: [{
      href: '/destination-guide',
      label: 'Destinations',
      icon: 'arrow-down',
      nested: [{
        href: '/destination-guide',
        label: 'Destination Guide',
        icon: 'globe',
        bgColor: 'd8-u-primary-bg-low-bg'
      }, {
        href: '/croatia',
        label: '<strong>Croatia</strong>, Original'
      }, {
        href: '/greece',
        label: '<strong>Greece</strong>, Athens'
      }, {
        href: '/sardinia',
        label: '<strong>Sardinia</strong>, Emerald Coast'
      }, {
        href: '/sardinia-refined-route',
        label: '<strong>Sardinia</strong>, Refined Route'
      }, {
        href: '/caribbean',
        label: '<strong>Caribbean</strong>, BVI'
      }
      // { href: '/polynesia-tahiti', label: '<strong>French Polynesia</strong>, Tahiti' }
      ]
    }, {
      href: '/destination-guide',
      label: 'Festivals',
      icon: 'arrow-down',
      nested: [{
        href: '/destination-guide',
        label: 'Destination Guide',
        icon: 'globe',
        bgColor: 'd8-u-primary-bg-low-bg'
      }, {
        href: '/ultra',
        label: '<strong>Croatia</strong>, Ultra Festival'
      }, {
        href: '/drumcode',
        label: '<strong>Croatia</strong>, Drumcode'
      }, {
        href: '/greece-applebum',
        label: '<strong>Greece</strong>, Applebum'
      }, {
        href: '/greece-peche',
        label: '<strong>Greece</strong>, Peche'
      }, {
        href: '/rhythm-waves',
        label: '<strong>Croatia</strong>, Rhythm & Waves'
      }, {
        href: '/vibras',
        label: '<strong>Greece</strong>, Vibras'
      }]
    }, {
      href: '/mba',
      label: 'Celebrations',
      icon: 'arrow-down',
      nested: [{
        href: '/mba',
        label: 'MBA Groups'
      }, {
        href: '/groups',
        label: 'Group Bookings'
      }, {
        href: '/corporate-groups',
        label: 'Corporate Groups'
      }]
    }, {
      href: '/summer-of-love',
      label: 'Discover',
      icon: 'arrow-down',
      nested: [{
        href: '/summer-of-love',
        label: 'Summer of Love'
      }, {
        href: '/how-it-works',
        label: 'How It Works'
      }, {
        href: '/whats-included',
        label: "What's Included"
      }, {
        href: '/work-with-us',
        label: 'Work With Us'
      }, {
        href: 'https://help.theyachtweek.com',
        label: 'FAQ'
      }]
    }],
    mobileLinks: [{
      href: '/how-it-works',
      label: 'How It Works'
    }, {
      href: '/destination-guide',
      label: 'Destinations'
    }, {
      href: '/account/crew-finder',
      label: 'Crew finder'
    }, {
      href: '/summer-of-love',
      label: 'Discover'
    }, {
      href: 'https://help.theyachtweek.com',
      label: 'F.A.Q.',
      template: 'AnchorLink'
    }]
  },
  tsw: {
    links: [{
      href: '/how-it-works',
      label: 'How It Works',
      nested: [{
        href: '/how-it-works',
        label: 'How It Works'
      }, {
        href: '/crew-finder',
        label: 'Crew Finder'
      }]
    }, {
      href: '/destination-guide',
      label: 'Destinations',
      nested: [{
        href: '/destination-guide',
        label: 'Destination Guide',
        hasHr: true
      }, {
        href: '/obertauern-austria',
        label: 'Austria'
      }, {
        href: '/aspen-snowmass',
        label: 'Aspen Snowmass'
      }]
    }, {
      href: '/about',
      label: 'About'
    }, {
      href: '/blog',
      label: 'Blog'
    }, {
      href: 'https://help.theskiweek.com',
      label: 'FAQ'
    }],
    mobileLinks: [{
      href: '/how-it-works',
      label: 'How it works'
    }, {
      href: '/destination-guide',
      label: 'Destinations'
    }, {
      href: '/about',
      label: 'About'
    }, {
      href: '/blog',
      label: 'Blog'
    }, {
      href: 'https://help.theskiweek.com',
      label: 'FAQ'
    }]
  },
  ynf: {
    links: [{
      href: '/how-it-works',
      label: 'How it works',
      icon: 'arrow-down',
      nested: [{
        href: '/about',
        label: 'Our story'
      }, {
        href: '/how-it-works',
        label: 'How it works'
      }, {
        href: '/how-it-works#staff',
        label: 'Our staff'
      }, {
        href: '/faq',
        label: 'FAQ'
      }]
    }, {
      href: '/group-sailing',
      label: 'Group sailing',
      icon: 'arrow-down',
      nested: [{
        href: '/expeditions/salt-escapes-x-yachts-and-friends',
        label: 'Caribbean Fitness Retreat'
      }, {
        href: '/expeditions/sicilian-yoga-retreat',
        label: 'Sicilian Yoga Retreat'
      }, {
        href: '/expeditions/croatia-classic',
        label: 'Croatia Classic'
      }, {
        href: '/expeditions/greece-classic',
        label: 'Greece Classic'
      }, {
        href: '/expeditions/tahiti',
        label: 'Tahiti Classic'
      }]
    }, {
      href: '/private-sailing',
      label: 'Private sailing'
    }, {
      href: '/contact',
      label: 'Contact'
    }],
    mobileLinks: [{
      href: '/about',
      label: 'Our story'
    }, {
      href: '/how-it-works',
      label: 'How it works'
    }, {
      href: '/group-sailing',
      label: 'Group sailing'
    }, {
      href: '/private-sailing',
      label: 'Private sailing'
    }, {
      href: '/faq',
      label: 'FAQ'
    }, {
      href: '/contact',
      label: 'Contact'
    }]
  }
};
navbar['tyw'].mobileLinks = navbar['tyw'].links;
var footer = {
  tyw: {
    text: 'Yacht Week brand and concept is owned by Day 8 AB - a private limited company registered in Stockholm, Sweden. Day 8 Experiences Ltd acts as a travel agent on the behalf of Yacht Week.',
    links: [{
      href: '/legal',
      label: 'Legal Stuff'
    }, {
      href: '/contact',
      label: 'Contact Us'
    }, {
      href: 'https://www.day8.com/',
      label: 'Learn About Day 8',
      template: 'AnchorLink',
      externalLink: true
    }],
    signup: {
      image: {
        url: 'https://assets.theyachtweek.com/wp-content/uploads/2020/02/newsletter.jpg',
        alt: 'Birds eye view on blue lagoon with rocks and yacht.'
      },
      text: 'We promise not to spam you',
      heading: 'Save your summer and sign up',
      subheading: 'Excited and ready to go?'
    },
    socialLinks: [{
      href: 'https://www.facebook.com/theyachtweek',
      label: 'Facebook - Yacht Week',
      icon: 'facebook-brand-2',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://instagram.com/theyachtweek/',
      label: 'Instagram - Yacht Week',
      icon: 'instagram',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.tiktok.com/@theyachtweek',
      label: 'Tiktok - Day 8 Experiences',
      icon: 'tiktok',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.youtube.com/user/TheYachtWeek',
      label: 'YouTube - Yacht Week',
      icon: 'youtube-brand',
      template: 'AnchorLink',
      externalLink: true
    }],
    navigationLinks: [{
      title: 'How It Works',
      links: [{
        href: '/how-it-works',
        label: 'How It Works'
      }, {
        href: '/account/crew-finder',
        label: 'Crew Finder'
      }, {
        href: '/important-information',
        label: 'Important Information'
      }, {
        href: '/whats-included',
        label: "What's included"
      }, {
        href: 'https://help.theyachtweek.com',
        label: 'FAQ'
      }]
    }, {
      title: 'What we do',
      links: [{
        href: '/destination-guide',
        label: 'Destinations'
      }, {
        href: '/agents',
        label: 'Agents'
      }, {
        href: 'https://help.theyachtweek.com',
        label: 'FAQ'
      }, {
        href: '/group-booking',
        label: 'Group Booking'
      }]
    }, {
      title: 'Who we are',
      links: [{
        href: '/about',
        label: 'About Us'
      }, {
        href: '/blog/category/press',
        label: 'Press'
      }, {
        href: '/partners',
        label: 'Partners'
      }]
    }],
    brands: [{
      href: 'https://day8.com/',
      iconName: 'day8-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.theskiweek.com/',
      iconName: 'tsw-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.quarterdeck.co/',
      iconName: 'qd-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://eurotrips.travel/',
      iconName: 'eurotrips-logo',
      template: 'AnchorLink',
      externalLink: true
    }],
    partners: [{
      href: '/partners/aegean',
      iconName: 'aegean-logo',
      template: 'AnchorLink',
      externalLink: false
    }]
  },
  tsw: {
    text: 'Copyright 2020 The Ski Week. The Ski Week is a private limited company registered in England and Wales with the number 09116193 VAT number: GB 191770987',
    links: [{
      href: '/legal',
      label: 'Legal Stuff'
    }, {
      href: '/contact',
      label: 'Contact Us'
    }],
    signup: {
      image: {
        url: 'https://assets.theskiweek.com/wp-content/uploads/2020/06/newsletter.jpg',
        alt: 'Man standing on Alps ready to skii'
      },
      text: 'We promise not to spam you',
      heading: 'Subscribe to our newsletter',
      subheading: 'Excited and ready to go?'
    },
    socialLinks: [{
      href: 'https://www.facebook.com/theskiweek',
      label: 'Facebook - The Ski Week',
      icon: 'facebook-brand-2',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://instagram.com/theskiweek/',
      label: 'Instagram - The Ski Week',
      icon: 'instagram',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.linkedin.com/company/day8/',
      label: 'LinkedIn - Day 8 Experiences',
      icon: 'linkedin-brand',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.youtube.com/user/TheSkiWeek',
      label: 'YouTube - The Ski Week',
      icon: 'youtube-brand',
      template: 'AnchorLink',
      externalLink: true
    }],
    navigationLinks: [{
      title: 'How It Works',
      links: [{
        href: '/how-it-works',
        label: 'How It Works'
      }, {
        href: '/crew-finder',
        label: 'Crew Finder'
      }]
    }, {
      title: 'The Ski Week',
      links: [{
        href: '/destination-guide',
        label: 'Destinations'
      }, {
        href: 'https://help.theskiweek.com',
        label: 'FAQ'
      }]
    }, {
      title: 'The company',
      links: [{
        href: '/about',
        label: 'About Us'
      }, {
        href: '/blog/category/press',
        label: 'Press'
      }]
    }],
    brands: [{
      href: 'https://www.quarterdeck.co/',
      iconName: 'qd-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.theyachtweek.com/',
      iconName: 'tyw-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.yachtsandfriends.com/',
      iconName: 'ynf-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://day8.com/',
      iconName: 'day8-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.ohso.co/',
      iconName: 'ohso-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://eurotrips.travel/',
      iconName: 'eurotrips-logo',
      template: 'AnchorLink',
      externalLink: true
    }]
  },
  ynf: {
    text: 'Yachts & Friends is owned by Day8 AB - a private limited company registered in Stockholm, Sweden',
    links: [{
      href: '/legal',
      label: 'Legal Stuff'
    }, {
      href: '/contact',
      label: 'Contact Us'
    }],
    signup: {
      image: {
        url: 'http://ynfproduction-uploads.s3.amazonaws.com/picadmin/homepage_image_edited.png',
        alt: 'Yachts sailing the ocean'
      },
      text: 'We promise not to spam you',
      heading: 'Subscribe to our newsletter',
      subheading: 'Excited and ready to go?'
    },
    socialLinks: [{
      href: 'https://www.facebook.com/YachtsAndFriends',
      label: 'Facebook - Yachts & Friends',
      icon: 'facebook',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'http://instagram.com/yachtsandfriends',
      label: 'Instagram - Yachts & Friends',
      icon: 'instagram',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.linkedin.com/company/day8/',
      label: 'LinkedIn - Day 8 Experiences',
      icon: 'linkedin',
      template: 'AnchorLink',
      externalLink: true
    }],
    navigationLinks: [{
      title: 'How It Works',
      links: [{
        href: '/',
        label: 'Our concept'
      }, {
        href: '/',
        label: 'Skippers'
      }, {
        href: '/',
        label: 'Chefs'
      }]
    }, {
      title: 'Yachts & Friends',
      links: [{
        href: '/',
        label: 'Our experiences'
      }, {
        href: '/',
        label: 'Bespoke'
      }, {
        href: '/faq',
        label: 'FAQ'
      }]
    }, {
      title: 'The company',
      links: [{
        href: '/',
        label: 'About Us'
      }, {
        href: '/',
        label: 'Press'
      }]
    }],
    partners: [{
      href: 'https://www.quarterdeck.co/',
      iconName: 'qd-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.theyachtweek.com/',
      iconName: 'tyw-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.theskiweek.com/',
      iconName: 'tsw-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://day8.com/',
      iconName: 'day8-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.ohso.co/',
      iconName: 'ohso-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://eurotrips.travel/',
      iconName: 'eurotrips-logo',
      template: 'AnchorLink',
      externalLink: true
    }]
  },
  qd: {
    text: '5th Floor The Office Group, 133 Whitechapel High St, London E1 7QA',
    links: [{
      href: 'https://s3.eu-west-1.amazonaws.com/quarterdeck.co/uploads/documents/QD_Privacy_Policy_2022.pdf',
      label: 'Privacy Policy'
    }, {
      href: 'https://s3-eu-west-1.amazonaws.com/quarterdeck-2023/uploads/documents/9/825-604-Academy2024BookingTCs.pdf',
      label: 'Academy Application Terms'
    }, {
      href: '/terms-and-conditions',
      label: 'Terms & Conditions'
    }],
    signup: {
      image: {
        url: 'https://assets.theyachtweek.com/wp-content/uploads/2020/02/newsletter.jpg',
        alt: 'Birds eye view on blue lagoon with rocks and yacht.'
      },
      text: 'We promise not to spam you',
      heading: 'Subscribe to our newsletter',
      subheading: 'Excited and ready to go?'
    },
    socialLinks: [{
      href: 'https://www.facebook.com/quarterdeck.co/?locale=en_GB',
      label: 'Facebook - Yacht Week',
      icon: 'facebook-brand-2',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.youtube.com/@quarterdecklife',
      label: 'YouTube - Yacht Week',
      icon: 'youtube-brand',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.instagram.com/quarterdeck.co/',
      label: 'Instagram - Yacht Week',
      icon: 'instagram',
      template: 'AnchorLink',
      externalLink: true
    }],
    navigationLinks: [{
      title: 'Skipper',
      links: [{
        href: '/become-a-skipper',
        label: 'Work as a skipper'
      }, {
        href: '/skipper-requirements',
        label: 'Requirements'
      }, {
        href: '/skipper-academy',
        label: 'Skipper Academy'
      }]
    }, {
      title: 'Host',
      links: [{
        href: '/become-a-host',
        label: 'Become a host'
      }, {
        href: '/host-requirements',
        label: 'Requirements'
      }, {
        href: '/host-academy',
        label: 'Host Academy'
      }]
    }, {
      title: 'Crew Hire',
      links: [{
        href: '/crew-hire',
        label: 'Crew Hire'
      }]
    }, {
      title: 'About',
      links: [{
        href: '/faq',
        label: 'FAQ'
      }, {
        href: '/the-team',
        label: 'The Team'
      }, {
        href: '/testimonials',
        label: 'Testimonials'
      }]
    }],
    partners: [{
      href: 'https://www.theyachtweek.com/',
      iconName: 'tyw-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.yachtsandfriends.com/',
      iconName: 'ynf-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://www.theskiweek.com/',
      iconName: 'tsw-logo',
      template: 'AnchorLink',
      externalLink: true
    }, {
      href: 'https://eurotrips.travel/',
      iconName: 'eurotrips-logo',
      template: 'AnchorLink',
      externalLink: true
    }]
  }
};
module.exports = {
  config: config,
  logo: logo,
  bookingLink: bookingLink,
  navbar: navbar,
  footer: footer
};